import { ProductPageLayout } from '../components/ProductPageLayout';

export function KonsistenKarakterWorkflowPage() {
    return <ProductPageLayout productId="konsisten-karakter-workflow" />;
}
